// extracted by mini-css-extract-plugin
module.exports = {"inviteLink":"add-Coach_inviteLink__2PmGA","btnSubmit":"add-Coach_btnSubmit__1QcrR"};